import { Component, OnInit } from '@angular/core';
import { DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { GroupDescriptor } from '@progress/kendo-data-query';
import { GridViewManager } from 'src/app/core/model/grid-view-manager';

@Component({
  selector: 'app-test-grids',
  templateUrl: './test-grids.component.html',
  styleUrls: ['./test-grids.component.scss']
})
export class TestGridsComponent implements OnInit
{
  public view = new GridViewManager();
  public count: number;
  public pageSizes = [5, 10, 25, 50, 100];
  public data = [];

  public ngOnInit(): void
  {
    for (let index = 1; index < 20; index++)
    {
      this.data.push({
        id: index,
        name: `Name ${index < 10 ? '0' + index : index}`,
        createdOn: `2022-01-${index < 10 ? '0' + index : index} 13:00:00.000Z`,
        group: `${Math.floor(Math.random() * (2 - 1 + 1) + 1)}`
      });
    }

    this.view.startLoading();
    this.count = this.data.length;
    this.data.forEach((x: any) =>
    {
      x.createdOn = new Date(x.createdOn);
    });
    this.view.setData(this.data);
    this.view.setSort([{ field: 'name', dir: 'asc' }]);
    this.view.stopLoading();
  }

  public dataStateChange(state: DataStateChangeEvent): void
  {
    this.view.setState(state);
  }

  public groupChange(groups: GroupDescriptor[]): void
  {
    this.view.setGroup(groups);
  }

}
